import { setFulfilled, setPending, setRejected } from '@ms/yammer-data-support';
import { Reducer } from 'redux';

import { GroupJoinedFulfilledAction, GroupLeftFulfilledAction } from '../../domains/groupJoinLeave/actions.types';
import { NavigationGroupsLoadAction } from '../../domains/navigationGroupsLoad/actions.types';
import {
  AddFavoriteCommunityFulfilledAction,
  RemoveFavoriteCommunityFulfilledAction,
} from '../../domains/viewerCommunityRelationships/actions.types';

import { ViewerCommunityIdSets } from './types';

export const initialState: ViewerCommunityIdSets = {
  pending: false,
  fulfilled: undefined,
  rejected: undefined,
};

export type ViewerCommunityIdSetsAction =
  | NavigationGroupsLoadAction
  | AddFavoriteCommunityFulfilledAction
  | RemoveFavoriteCommunityFulfilledAction
  | GroupJoinedFulfilledAction
  | GroupLeftFulfilledAction;

const addFavoriteFulfilled = (state: ViewerCommunityIdSets, action: AddFavoriteCommunityFulfilledAction) => {
  if (!state.fulfilled) {
    return state;
  }

  return {
    ...state,
    fulfilled: {
      ...state.fulfilled,
      favoriteCommunityIds: [...state.fulfilled.favoriteCommunityIds, action.payload.id],
    },
  };
};

const removeFavoriteFulfilled = (state: ViewerCommunityIdSets, action: RemoveFavoriteCommunityFulfilledAction) => {
  if (!state.fulfilled) {
    return state;
  }

  return {
    ...state,
    fulfilled: {
      ...state.fulfilled,
      favoriteCommunityIds: state.fulfilled.favoriteCommunityIds.filter((id) => id !== action.payload.id),
    },
  };
};

const groupJoinedFulfilled = (state: ViewerCommunityIdSets, action: GroupJoinedFulfilledAction) => {
  if (!state.fulfilled) {
    return state;
  }

  return {
    ...state,
    fulfilled: {
      ...state.fulfilled,
      communityIds: [action.payload.groupId, ...state.fulfilled.communityIds],
    },
  };
};

const groupLeftFulfilled = (state: ViewerCommunityIdSets, action: GroupLeftFulfilledAction) => {
  if (!state.fulfilled) {
    return state;
  }

  return {
    ...state,
    fulfilled: {
      communityIds: state.fulfilled.communityIds.filter((x) => x !== action.payload.groupId),
      favoriteCommunityIds: state.fulfilled.favoriteCommunityIds.filter((x) => x !== action.payload.groupId),
    },
  };
};

const reducer: Reducer<ViewerCommunityIdSets, ViewerCommunityIdSetsAction> = (state = initialState, action) => {
  switch (action.type) {
    case 'NAVIGATION_GROUPS.LOAD_PENDING':
      return setPending();
    case 'NAVIGATION_GROUPS.LOAD_REJECTED':
      return setRejected(action.payload.error);
    case 'NAVIGATION_GROUPS.LOAD_FULFILLED':
      return setFulfilled(action.payload.entities.viewerCommunityIdSets);
    case 'COMMUNITY.ADD_FAVORITE_FULFILLED':
      return addFavoriteFulfilled(state, action);
    case 'COMMUNITY.REMOVE_FAVORITE_FULFILLED':
      return removeFavoriteFulfilled(state, action);
    case 'GROUP.JOINED_FULFILLED':
      return groupJoinedFulfilled(state, action);
    case 'GROUP.LEFT_FULFILLED':
      return groupLeftFulfilled(state, action);
    default:
      return state;
  }
};

export default reducer;
